
import { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import AdminNavBar from "./AdminNavBar";
import { FetchActiveUsers, User, UserSelect } from "./UserSelect";
import UserNavBar from "./UserNavBar";
import { SelectInstance } from "react-select";


const EditUser =  () => {
	var userRef = useRef<HTMLSelectElement>(null)
	var selectRef = useRef<SelectInstance<Option | null>>(null)

	const [isUserSet, setIsUserSet] = useState(false)
	const [users, setUsers] = useState<User[]>([])
	const [selectedUser, setSelectedUser] = useState<User>({ id: 0, first_name: "", middle_name: "", last_name: "", signed_in: false, photo: "", active: false, email: "", password: "", role: "" })
	const [firstName, setFirstName] = useState("")
	const [middleName, setMiddleName] = useState("")
	const [lastName, setLastName] = useState("")
	const [email, setEmail] = useState("")
	const [password, setPassword] = useState("")
	const [role, setRole] = useState("")
	const [photoChanged, setPhotoChanged] = useState(false)
	const [respMsg, setRespMsg] = useState("")
	const [inputKey, setInputKey] = useState(Date.now());
	const [units, setUnits] = useState<Unit[]>([{unit:"", id:0, active:false, selected:false}])
	var [selectedUnits, setSelectedUnits] = useState<string[]>([])
	const [locations, setLocations] = useState<Location[]>([])
	const [selectedLocations, setSelectedLocations] = useState<string[]>([])
	const [defaultUnit, setDefaultUnit] = useState<Unit>({id:0, unit:"", active: false, selected: false})

	interface Option {
		value: any;
		label: string;
	}

	interface Location {
		id: number;
		short_name: string;
		long_name: string;
	}

	interface Unit {
		id: number
		unit: string
		active: boolean
		selected: boolean
	}

	interface FileUploadState {
		file: File | null;
		previewUrl: string | null;
	}

	const [fileState, setFileState] = useState<FileUploadState>({
		file: null,
		previewUrl: null,
	});


	const handleUnitsChange = (event: ChangeEvent<HTMLSelectElement>) => {
		const values = Array.from(event.target.selectedOptions, (option) => option.value);
		setSelectedUnits(values)
}

	const handleFirstNameChange = (event: ChangeEvent<HTMLInputElement>) => {
		setFirstName(event.target.value)
	}
	
	const handleMiddleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
		setMiddleName(event.target.value)
	}
	
	const handleLastNameChange = (event: ChangeEvent<HTMLInputElement>) => {
		setLastName(event.target.value)
	}
	const handleEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
		setEmail(event.target.value)
	}
	const handlePasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
		setPassword(event.target.value)
	}
	const handleRoleChange = (event: ChangeEvent<HTMLSelectElement>) => {
		setRole(event.target.value)
	}

	const handleDefaultUnitChange = (event: ChangeEvent<HTMLSelectElement>) => {
		const value = event.target.value;
		const unit = units.find(loc => loc.id.toString() ===
			value)
		if (unit) {
			setDefaultUnit(unit)
		}
	}

	const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
		const files = event.target.files;
		if (files && files.length > 0) {
			const selectedFile = files[0];
			setFileState({
				file: selectedFile,
				previewUrl: (window.URL ? URL : webkitURL).createObjectURL(selectedFile),
			});
			setPhotoChanged(true)
		} else {
			setFileState({ file: null, previewUrl: "" })
		}
		setInputKey(Date.now())
	};

	const revokeFileImage = () => {
		if (fileState && fileState.previewUrl) {
			(window.URL ? URL : webkitURL).revokeObjectURL(fileState.previewUrl);
		}
	}

	const getUnits = useCallback(async () => {
		const response = await fetch(process.env.REACT_APP_API+"/api/units")
		const results = await response.json()
		var localUnits: Unit[] = []
		for (var i= 0; i < results.length; i++) {
			var unit:Unit = {id: results[i].id, unit:results[i].unit, active:results[i].active, selected:false}
			localUnits.push(unit)
		}
		setUnits(localUnits)
	}, [setUnits])

	const getLocations = useCallback(async () => {
		const response = await fetch(process.env.REACT_APP_API + "/api/locations")
		const results = await response.json()
		setLocations(results)
	}, [setLocations])

	useEffect(() => {

		getUnits()
	
		getLocations()
		FetchActiveUsers(setUsers)
		if (selectedUser.id > 0) {
			setFirstName(selectedUser.first_name)
			setMiddleName(selectedUser.middle_name)
			setLastName(selectedUser.last_name)
			setEmail(selectedUser.email)
			setRole(selectedUser.role)

			if (!photoChanged) {
				console.log("no photo changed")
				if (selectedUser.photo) {
					fileState.previewUrl = process.env.REACT_APP_API+"/api/photo/" + selectedUser.photo + "?n=" + String(Math.random())
				} else {
					fileState.previewUrl = ""
				}
			}
			const getUserUnits = async (id:number) => {
				const response = await fetch(process.env.REACT_APP_API+"/api/unitsByUser?userID=" + id)
				const results = await response.json()
				var selectedUnits:string[] = []
				if (results && results.ids && results.ids.length > 0) {
					for (var i = 0; i < units.length; i++) {
						if (results.ids.indexOf(units[i].id) > -1) {
							units[i].selected = true
							selectedUnits.push(units[i].id.toString())
							setSelectedUnits(selectedUnits)
						}
					}
				} else {
					selectedUnits = []
					setSelectedUnits(selectedUnits)
				}
			}
			getUserUnits(selectedUser.id)
			const getUserLocations = async (id:number) => {
				const response = await fetch(process.env.REACT_APP_API+"/api/locationsByUser?userID=" + id)
				const results = await response.json()

				var selectedLocations:string[] = []
				if (results && results.ids && results.ids.length > 0) {
					for (var i = 0; i < locations.length; i++) {
						if (results.ids.indexOf(locations[i].id) > -1) {
							selectedLocations.push(locations[i].id.toString())
							setSelectedLocations(selectedLocations)
						}
					}
				}
				else {
					selectedLocations = []
					setSelectedLocations(selectedLocations)
				}
			}
			getUserLocations(selectedUser.id)
			const getDefaultUnit = async (id:number) => {
				const response = await fetch(process.env.REACT_APP_API+"/api/defaultUnitByUser?userID=" + id)
				const result = await response.json()
				if (result && result.id) {
					var defaultUnit:Unit = {id: result.id, unit: result.unit, active: result.active, selected: true}
					setDefaultUnit(defaultUnit)
				} else {
					setDefaultUnit({id:0, unit:"", active: false, selected: false})
				}
			}
			getDefaultUnit(selectedUser.id)
		}
	}, [fileState, selectedUser, photoChanged,fileState.previewUrl, getLocations, getUnits,setUsers,])

	const handleLocationsChange = (event: ChangeEvent<HTMLSelectElement>) => {
		const values = Array.from(event.target.selectedOptions, (option) => option.value);
		setSelectedLocations(values)
	}

	async function editUser() {
		if (
			selectedUser.id &&
			firstName &&
			lastName && selectedUnits.length > 0 &&
			selectedLocations.length > 0 &&
			role
		) {
			const formData = new FormData()
			formData.append("id", String(selectedUser.id))
			formData.append("first_name", firstName)
			if (middleName) {
				formData.append("middle_name", middleName)
			}
			formData.append("last_name", lastName)
			if (fileState && fileState.file) {
				formData.append("photo", fileState.file)
			}
			if (email) {
				formData.append("email", email)
			}
			if (password) {
				formData.append("password", password)
			}
			if (role) {
				formData.append("role", role)
			}

			formData.append("units", JSON.stringify(selectedUnits))
			formData.append("locations", JSON.stringify(selectedLocations))
			formData.append("default_unit", defaultUnit.id.toString())
			const resp = await fetch(process.env.REACT_APP_API + "/api/user", {
				method: "PUT",
				body: formData
			})

			const msg = await resp.json()
			setRespMsg(msg.msg)
			setFirstName("")
			setLastName("")
			setMiddleName("")
			setEmail("")
			setRole("")
			setPassword("")
			setSelectedUnits([])
			setSelectedLocations([])
			if (userRef && userRef.current) {
				userRef.current.value=""
			}
			if (fileState.previewUrl) {
				fileState.previewUrl = null
			}
			setIsUserSet(false)
			if (selectRef && selectRef.current) {
				selectRef.current.setValue({ value: 0, label: "" }, "deselect-option")
			}
		} else {
			setRespMsg("First name, last name, unit and location are required")
		}
	}



		return (
			<div className="resilire">
				<AdminNavBar />
				<UserNavBar />
				<h3>Edit User</h3>
				<UserSelect isVisible={isUserSet} setIsVisible={setIsUserSet} setUsers={setUsers} users={users} setSelectedUser={setSelectedUser} ref={userRef} selectRef={selectRef}  onChange={() => { if (photoChanged) { setPhotoChanged(false) } }} />
				{isUserSet &&
					<div className="resilire" key={selectedUser.id} >
						<label htmlFor="first_name">First Name</label>
						<input id="first_name" name="first_name" value={firstName} onChange={handleFirstNameChange}></input>
						<label htmlFor="middle_name">Middle Name</label>
						<input id="middle_name" name="middle_name" value={middleName} onChange={handleMiddleNameChange}></input>
						<label htmlFor="last_name">Last Name</label>
						<input id="last_name" name="last_name" value={lastName} onChange={handleLastNameChange}></input>
						<label htmlFor="email">Username</label>
						<input type="email" name="email" id="email" value={email} onChange={handleEmailChange} />
						<label htmlFor="password">Password (Leave blank for no change)</label>
						<input type="password" name="password" id="password" value={password} onChange={handlePasswordChange} />
						<label htmlFor="units">Units</label>
						<select id="units" name="units" size={1} value={selectedUnits} onChange={handleUnitsChange} multiple>
							{
								units.map((unit) => (
									<option value={unit.id} key={unit.id}>{unit.unit}</option>
								))
							}
						</select>
						<label htmlFor="locations">Locations</label>
						<select id="locations" name="locations" size={1} value={selectedLocations} onChange={handleLocationsChange} multiple>
							{
								locations.map((location) => (
									<option value={location.id} key={location.id}>{location.short_name} - {location.long_name}</option>
								))
							}
						</select>
						<label htmlFor="default_unit">Default Unit</label>
						<select id="default_unit" name="default_unit" value={defaultUnit.id} size={1} onChange={handleDefaultUnitChange}>
							<option value=""></option>
							{
								units.map((unit) => (
									<option value={unit.id} key={unit.id}>{unit.unit}</option>
								))
							}
						</select>
						<label htmlFor="role">Role</label>
						<select id="role" name="role" value={role} onChange={handleRoleChange}>
							<option value="admin">Admin</option>
							<option value="clinic">In-Clinic</option>
							<option value="mobile">Mobile</option>
						</select>
						<label htmlFor="userphoto">Photo</label>
						<input type="file" accept="image/*" onChange={handleFileChange} name="userphoto" id="userphoto" key={inputKey} />
						{fileState.previewUrl && (
							<img src={fileState.previewUrl} alt="Preview" onLoad={revokeFileImage} style={{ maxWidth: '200px', marginTop: '10px' }} />
						)}
						<button onClick={editUser}>Submit</button>
					</div>
				}

				{respMsg && (
					<div>
						{respMsg}
					</div>
				)}
			</div>
		)
};

export default EditUser;
